module.exports = __webpack_public_path__ + "static/media/work10.615282eb.jpg";